import { useSelector } from "react-redux";
import {
  isWebOnboardingV2BEnabledSelector,
  neverLoadedRemoteConfigurationSelector,
} from "@state/remoteConfiguration/remoteConfiguration.selectors";

export interface WebOnboardingV2B {
  /** Deal-anchored onboarding is on for this investor. */
  isActive: boolean;
  /** Remote config has not arrived, so the arm is not known yet. */
  isResolving: boolean;
}

export const useWebOnboardingV2B = (): WebOnboardingV2B => {
  const isEnabled = useSelector(isWebOnboardingV2BEnabledSelector);
  const neverLoadedRemoteConfig = useSelector(
    neverLoadedRemoteConfigurationSelector
  );

  return {
    isActive: isEnabled && !neverLoadedRemoteConfig,
    isResolving: neverLoadedRemoteConfig,
  };
};
